<template>
  <div :class="['error', 'p-2', message ? 'error-show' : null]" v-html="message" @click="$parent.error = null" />
</template>
<script>
export default {
  name: 'Error',
  props: {
    message: {
      type: String
    }
  }
}
</script>
<style>
.error
{
  font-size: .8em;
  position: fixed;
  top: var(--em-8);
  right: var(--em-8);
  transition: var(--ease-in-out-back);
  background: var(--red);
  color: var(--white);
  width: 320px;
  border-radius: var(--border-radius);
  filter: drop-shadow(0 0 var(--em-0) var(--darkest));
  display: none;
  pointer-events: none;
  line-height: var(--em-6);
}

.error.error-show
{
  display: block;
  pointer-events: all;
}
</style>



// WEBPACK FOOTER //
// src/components/error.vue